import React, { useState, useMemo } from 'react';
import { Input, Spin } from 'antd';
import { Tick02Icon } from '../../../components/icons';

export default function BookmarkMultiSelect({ bookmarksQuery, value, onChange }) {
  const [search, setSearch] = useState('');

  const filteredBookmarks = useMemo(() => {
    const items = bookmarksQuery.data?.results || [];
    if (!search) return items;
    const lower = search.toLowerCase();
    return items.filter((b) => b.name?.toLowerCase().includes(lower));
  }, [bookmarksQuery.data, search]);

  const toggleBookmark = (id) => {
    if (!onChange) return;
    onChange(value.includes(id) ? value.filter((bid) => bid !== id) : [...value, id]);
  };

  if (bookmarksQuery.isLoading) {
    return (
      <div className="flex items-center justify-center p-4 w-64">
        <Spin />
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-2 p-2 w-64">
      <Input
        size="small"
        placeholder="Search bookmarks..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />
      <div className="max-h-64 overflow-y-auto">
        {filteredBookmarks.map((bookmark) => (
          <div
            key={bookmark._id}
            onClick={() => toggleBookmark(bookmark._id)}
            className={`${
              value.includes(bookmark._id) ? 'text-blue-500' : ' text-neutral-500'
            } p-2 px-6 cursor-pointer flex gap-2 items-center relative`}
          >
            {value.includes(bookmark._id) && <Tick02Icon className="w-4 h-4 text-blue-500 absolute left-0" />}
            {bookmark.name}
          </div>
        ))}
        {bookmarksQuery.data?.results && bookmarksQuery.data.results.length > 0 && filteredBookmarks.length === 0 && (
          <div className="text-xs text-neutral-400 px-2 py-1">No bookmarks found</div>
        )}
        {!bookmarksQuery.isLoading && (!bookmarksQuery.data?.results || bookmarksQuery.data.results.length === 0) && (
          <div className="text-xs text-neutral-400 px-2 py-1">No bookmarks available</div>
        )}
      </div>
    </div>
  );
}
